import { useStore } from "@/store"
import { SystemConfig } from "@/types"

const useSysConfig = (): SystemConfig => {
  const [sysConfig] = useStore((state) => [state.sysConfig])
  return sysConfig
}

export { useSysConfig }
export default useSysConfig
